module.exports = __webpack_public_path__ + "img/2427b104c23e9ee48a9cc9a6968b85c5.png";